import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import AdminDashboardTabTypes from '../redux/actions/types/AdminDashboardTabTypes';
import ButtonTabs from '../../../../core/modules/common/components/ButtonTabs';
import GlobalPresetsOperatorContainer from './GlobalPresetOperatorContainer';
import GlobalPresetsOperatorImpcContainer from './GlobalPresetsOperatorImpcContainer';
import GlobalPresetsLocationContainer from './GlobalPresetsLocationContainer';
import GlobalPresetsDespatchTypeContainer from './GlobalPresetsDespatchTypeContainer';
import GloabalPresetsOperatorMailboxContainer from './GloabalPresetsOperatorMailboxContainer';
import GlobalPresetsMrdImpcContainer from './GlobalPresetsMrdImpcContainer';
import { getAdminTabStatus } from '../redux/selectors/AdminDashboardSelectors';
import WarningModal from '../../../common/components/WarningModal';
import { setTabButtonStatus } from '../redux/actions/AdminDashboardActions';

const tabsGlobalPresets = [
  {
    value: AdminDashboardTabTypes.OPERATOR,
    label: 'Operator',
  },
  {
    value: AdminDashboardTabTypes.OPERATORIMPC,
    label: 'Operator / IMPC',
  },
  {
    value: AdminDashboardTabTypes.LOCATION,
    label: 'Location',
  },
  {
    value: AdminDashboardTabTypes.DESPATCHTYPE,
    label: 'Despacth type',
  },
  {
    value: AdminDashboardTabTypes.OPERATORMAILBOX,
    label: 'Operator / Mailbox',
  },
  {
    value: AdminDashboardTabTypes.MRDIMPC,
    label: 'MRD IMPC',
  },
];

export class AdminGlobalPresetContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 'OPERATOR',
      openDisabledWarnModal: false,
      tabWithoutSaveModal: 'OPERATOR',
    };
  }

  onCloseModal = () => {
    this.setState({
      openDisabledWarnModal: false,
    });
  };

  isOperatorActive = () =>
    this.state.activeTab === AdminDashboardTabTypes.OPERATOR;

  isOperatorImpcActive = () =>
    this.state.activeTab === AdminDashboardTabTypes.OPERATORIMPC;

  isLocationActive = () =>
    this.state.activeTab === AdminDashboardTabTypes.LOCATION;

  isDespatchTypeActive = () =>
    this.state.activeTab === AdminDashboardTabTypes.DESPATCHTYPE;

  isOperatorMailboxActive = () =>
    this.state.activeTab === AdminDashboardTabTypes.OPERATORMAILBOX;

  isMrdImpcActive = () =>
    this.state.activeTab === AdminDashboardTabTypes.MRDIMPC;

  navigateTab = (activeTab) => {
    this.setState({
      // eslint-disable-next-line react/no-access-state-in-setstate
      activeTab: this.props.status ? this.state.activeTab : activeTab,
      openDisabledWarnModal: !!this.props.status,
      tabWithoutSaveModal: activeTab,
    });
  };

  changeTabWithoutSave = () => {
    this.props.setTabButtonStatus(false);
    this.setState({
      openDisabledWarnModal: false,
    });
    setTimeout(() => {
      this.navigateTab(this.state.tabWithoutSaveModal);
    }, 1000);
  };

  render() {
    return (
      <div className="admin-dashboard-global-presets">
        <ButtonTabs
          tabs={tabsGlobalPresets}
          activeTab={this.state.activeTab}
          onChange={this.navigateTab}
        />
        {this.isOperatorActive() &&
        <GlobalPresetsOperatorContainer />
        }
        {this.isOperatorImpcActive() &&
        <GlobalPresetsOperatorImpcContainer />
        }
        {this.isLocationActive() &&
        <GlobalPresetsLocationContainer />
        }
        {this.isDespatchTypeActive() &&
        <GlobalPresetsDespatchTypeContainer />
        }
        {this.isOperatorMailboxActive() &&
        <GloabalPresetsOperatorMailboxContainer />
        }
        {this.isMrdImpcActive() &&
        <GlobalPresetsMrdImpcContainer />
        }
        {this.state.openDisabledWarnModal &&
        <WarningModal
          headerFormattedMessageId="app.warning.change.tab.without.save"
          onCloseModal={this.onCloseModal}
          deleteSelection={this.changeTabWithoutSave}
        />
        }
      </div>
    );
  }
}

AdminGlobalPresetContainer.propTypes = {
  status: PropTypes.bool,
  setTabButtonStatus: PropTypes.func,
};

const mapDispatchToProps = dispatch => bindActionCreators({
  setTabButtonStatus,
}, dispatch);

const mapStateToProps = state => ({
  status: getAdminTabStatus(state),
});

/* Needed for prop-types with cloneElement */
export const ConnectedAdminGlobalPresetContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(AdminGlobalPresetContainer);

export default ConnectedAdminGlobalPresetContainer;

